import * as React from 'react';
import {
	Dropdown,
	DropdownContent,
	DropdownEllipsisTrigger,
	DropdownItem,
} from '../../../../../web/components-v2/Dropdown';
import { styleSheet } from '../styles';

interface IProps {
	onClickToArchive?: () => void;
	onClickToBrowse?: () => void;
	onClickToRename?: () => void;
}

export const CategoryCardOptions: React.FC<IProps> = ({ onClickToArchive, onClickToBrowse }) => {
	return (
		<Dropdown>
			<DropdownEllipsisTrigger />
			<DropdownContent styles={[styleSheet.moreMenuContent]}>
				<DropdownItem onClick={onClickToBrowse} styles={[styleSheet.moreMenuItem]}>
					Browse Calls
				</DropdownItem>
				<DropdownItem onClick={onClickToArchive} styles={[styleSheet.moreMenuItem]}>
					Archive
				</DropdownItem>
			</DropdownContent>
		</Dropdown>
	);
};
